import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { OnboardingHomeComponent } from '@angular-workspace/feature';
import { OrgAdminSidebarComponent } from '../sidebar/org-admin-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'app-org-admin-add-dataset-new',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    OrgAdminSidebarComponent,
    PageHeaderComponent,
    OnboardingHomeComponent,
  ],
  templateUrl: './add-dataset-new.component.html',
  styleUrl: './add-dataset-new.component.scss',
})
export class OrgAdminAddDatasetNewComponent {
  private readonly toasterService = inject(ToasterService);

  onSubmitError(message: string): void {
    this.toasterService.error(message);
  }

  onSubmitSuccess(message: string): void {
    this.toasterService.success(message);
  }
}
